module.exports = __webpack_public_path__ + "img/linen-fabric.9d176d5e.webp";